import { Box, Title } from 'components'
import { SectionContainer } from 'components/SectionContainer'
import { useResponsive } from 'hooks'
import { getSpacing } from 'utils'
import { ActivityHistory } from './ActivityHistory'
import { CreditScore } from './CreditScore'
import { PositionSummary } from './Summary'
import { Vault } from './Vault'

const BorrowMobile = () => {
  return (
    <Box marginLeft={getSpacing('m')} marginRight={getSpacing('m')}>
      <Title tag="h1" size="xxl">
        Borrow
      </Title>
      <Box marginTop={getSpacing('xl')}>
        <Box width="100%" height="260px">
          <CreditScore />
        </Box>
      </Box>
      <Box marginTop={getSpacing('m')}>
        <Box width="100%" height="364px">
          <PositionSummary />
        </Box>
      </Box>
      <Box marginTop={getSpacing('m')}>
        <Title tag="h2" size="m">
          Vaults
        </Title>
      </Box>
      <Vault />
      <Box marginTop={getSpacing('m')}>
        <Title tag="h2" size="m">
          Loan history
        </Title>
      </Box>
      <SectionContainer
        marginTop={getSpacing('m')}
        paddingTop={getSpacing('m')}
        paddingBottom={getSpacing('s')}
      >
        <ActivityHistory />
      </SectionContainer>
    </Box>
  )
}

const BorrowDesktop = () => {
  return (
    <Box marginLeft={getSpacing('m')} marginRight={getSpacing('m')}>
      <Title tag="h1" size="xxl" center>
        Borrow
      </Title>
      <Box flexDirection="row" marginTop={getSpacing('l')}>
        <Box width="380px" height="278px">
          <CreditScore />
        </Box>
        <Box flexGrow={1} marginLeft={getSpacing('m')}>
          <Box height="278px">
            <PositionSummary />
          </Box>
        </Box>
      </Box>
      <Vault />
      <SectionContainer marginTop={getSpacing('m')} padding={null} paddingBottom={getSpacing('m')}>
        <Box marginTop={getSpacing('m')} marginLeft={getSpacing('m')}>
          <Title tag="h3" size="m">
            Loan history
          </Title>
        </Box>
        <Box marginTop={getSpacing('m')}>
          <ActivityHistory />
        </Box>
      </SectionContainer>
    </Box>
  )
}

export const Borrow = () => {
  const { width } = useResponsive()

  return width < 800 ? <BorrowMobile /> : <BorrowDesktop />
}
